module.exports = __webpack_public_path__ + "img/thumb_13.35c21b9c.jpg";